import React, { useEffect, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import {
  DashboardOutlined,
  TeamOutlined,
  CreditCardOutlined,
  BankOutlined,
  BarChartOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import Logo from "../../Logo/Logo";
import MobileLogo from "../../Logo/MobileLogo";
import UserAvatar from "../../blocks/UserAvatar";
import { USER } from "../../constants/defaultKeys";
import { getItem } from "../../helpers/localStorage";
import { isDesktop } from "react-device-detect";
import "./AdminLayoutM3.css";

const NAV_ITEMS = [
  { key: "dashboard", path: "/admin/dashboard", label: "Dashboard", icon: DashboardOutlined },
  { key: "analytics", path: "/admin/analytics", label: "Analytics", icon: BarChartOutlined, platformAdminOnly: true },
  { key: "users", path: "/admin/users", label: "Users", icon: TeamOutlined, hideForClientAdmin: true },
  { key: "subscriptions", path: "/admin/subscriptions", label: "Payments", icon: CreditCardOutlined, hideForClientAdmin: true },
  { key: "vendors", path: "/admin/vendors", label: "Vendors", icon: BankOutlined },
];

function AdminLayoutM3({ children, showFooter = true }) {
  const history = useHistory();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("dashboard");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const userDetails = JSON.parse(getItem(USER) || "{}");

  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    const section = pathParts[1] || "dashboard";
    setActiveKey(section);
  }, [location.pathname]);

  const navItems = NAV_ITEMS.filter((item) => {
    if (item.hideForClientAdmin && userDetails?.is_client_admin) return false;
    if (item.platformAdminOnly && !userDetails?.is_admin) return false;
    return true;
  });

  return (
    <div className={`admin-layout-m3 ${sidebarCollapsed ? "admin-layout-m3--sidebar-collapsed" : ""}`}>
      <header className="admin-layout-m3__top-bar" role="banner">
        <div
          className="admin-layout-m3__logo"
          onClick={() => history.push("/admin/dashboard")}
          onKeyDown={(e) => e.key === "Enter" && history.push("/admin/dashboard")}
          role="button"
          tabIndex={0}
          aria-label="Go to dashboard"
        >
          {isDesktop ? <Logo /> : <MobileLogo />}
        </div>
        <div className="admin-layout-m3__avatar">
          <UserAvatar />
        </div>
      </header>

      <div className="admin-layout-m3__main">
        <aside className="admin-layout-m3__sidebar" aria-label="Admin navigation" aria-expanded={!sidebarCollapsed}>
          <nav>
            <ul className="admin-layout-m3__nav">
              {navItems.map((item) => {
                const isActive = activeKey === item.key;
                const Icon = item.icon;
                return (
                  <li key={item.key} className="admin-layout-m3__nav-item">
                    <Link
                      to={item.path}
                      className={`admin-layout-m3__nav-link ${isActive ? "admin-layout-m3__nav-link--active" : ""}`}
                      onClick={() => setActiveKey(item.key)}
                      title={sidebarCollapsed ? item.label : undefined}
                    >
                      <span className="admin-layout-m3__nav-icon" aria-hidden>
                        <Icon />
                      </span>
                      <span className="admin-layout-m3__nav-label">{item.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
          <button
            type="button"
            className="admin-layout-m3__sidebar-toggle"
            onClick={() => setSidebarCollapsed((c) => !c)}
            aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </button>
        </aside>

        <main className="admin-layout-m3__content" role="main">
          {children}
        </main>
      </div>

      {showFooter && (
        <footer className="admin-layout-m3__footer">
          Copyright © 2021 i4Strategies. All Rights Reserved |{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>
        </footer>
      )}
    </div>
  );
}

export default AdminLayoutM3;
